import { twMerge } from "tailwind-merge";

export const OrientedPopper = ({
  selectOrientedIndex,
  currentIndex,
  orientedList,
}: {
  selectOrientedIndex: (index: number) => void;
  currentIndex: number;
  orientedList: string[];
}) => (
  <div className="absolute right-0 top-4 z-30 mx-auto whitespace-nowrap rounded-md border border-zinc-200 bg-white py-1">
    {orientedList.map((name: string, index: number) => (
      <div
        role="menuitem"
        aria-label="oriented"
        key={index}
        className={twMerge(
          "cursor-pointer select-none px-4 py-1.5 text-center text-sm font-normal hover:bg-sky-50",
          currentIndex === index && "bg-sky-100 text-sky-700"
        )}
        onClick={(e) => {
          e.stopPropagation();
          selectOrientedIndex(index);
        }}
      >
        {name}
      </div>
    ))}
  </div>
);
